import { atom } from 'recoil';
import { type QueueModel } from '../types/models/queue-model';

export const queuesState = atom<QueueModel[]>({
  key: 'Queues',
  default: []
});
